export interface StatusDisplayConfig {
  label: string;
  className: string;
}

export const STORE_PAYMENT_LOG_PAYMENT_METHOD = {
  ON_SITE_PAYMENT: 'On site payment',
  PAY_WITH_HOSLOG_POINTS: 'Pay with Hosulog points',
} as const;

export const STORE_PAYMENT_LOG_CLUB_VERIFICATION = {
  VISITED: 'A',
  PENDING: 'P',
} as const;

export const STORE_PAYMENT_LOG_TRANSACTION_STATUS = {
  SUCCESS: 'S',
  PENDING: 'P',
  RECEIVED: 'Received',
} as const;

export const PAYMENT_METHOD_MAP: Record<
  string,
  {
    label: {
      en: string;
      ja: string;
    };
    className: string;
  }
> = {
  [STORE_PAYMENT_LOG_PAYMENT_METHOD.ON_SITE_PAYMENT]: {
    label: {
      en: 'On site payment',
      ja: '現地払い',
    },
    className: 'text-warning',
  },
  'On Arrival': {
    label: {
      en: 'On site payment',
      ja: '現地払い',
    },
    className: 'text-warning',
  },
  現地払い: {
    label: {
      en: 'On site payment',
      ja: '現地払い',
    },
    className: 'text-warning',
  },
  [STORE_PAYMENT_LOG_PAYMENT_METHOD.PAY_WITH_HOSLOG_POINTS]: {
    label: {
      en: 'Pay with Hosulog points',
      ja: 'ホスログポイント',
    },
    className: 'text-success',
  },
  PAY_WITH_HOSLOG_POINTS: {
    label: {
      en: 'Pay with Hosulog points',
      ja: 'ホスログポイント',
    },
    className: 'text-success',
  },
  'Pay with Hoslog points': {
    label: {
      en: 'Pay with Hosulog points',
      ja: 'ホスログポイント',
    },
    className: 'text-success',
  },
  'Hoslog Points': {
    label: {
      en: 'Pay with Hosulog points',
      ja: 'ホスログポイント',
    },
    className: 'text-success',
  },
  ホスログポイント: {
    label: {
      en: 'Pay with Hosulog points',
      ja: 'ホスログポイント',
    },
    className: 'text-success',
  },
};

export const CLUB_VERIFICATION_MAP: Record<
  string,
  {
    label: {
      en: string;
      ja: string;
    };
    className: string;
  }
> = {
  [STORE_PAYMENT_LOG_CLUB_VERIFICATION.VISITED]: {
    label: {
      en: 'Visited',
      ja: '訪問済み',
    },
    className: 'text-success',
  },
  Visited: {
    label: {
      en: 'Visited',
      ja: '訪問済み',
    },
    className: 'text-success',
  },
  訪問済み: {
    label: {
      en: 'Visited',
      ja: '訪問済み',
    },
    className: 'text-success',
  },
  [STORE_PAYMENT_LOG_CLUB_VERIFICATION.PENDING]: {
    label: {
      en: 'Pending',
      ja: '保留中',
    },
    className: 'text-warning',
  },
  Pending: {
    label: {
      en: 'Pending',
      ja: '保留中',
    },
    className: 'text-warning',
  },
  保留中: {
    label: {
      en: 'Pending',
      ja: '保留中',
    },
    className: 'text-warning',
  },
};

export const TRANSACTION_STATUS_MAP: Record<
  string,
  {
    label: {
      en: string;
      ja: string;
    };
    className: string;
  }
> = {
  [STORE_PAYMENT_LOG_TRANSACTION_STATUS.SUCCESS]: {
    label: {
      en: 'Received',
      ja: '受領済み',
    },
    className: 'text-success',
  },
  [STORE_PAYMENT_LOG_TRANSACTION_STATUS.RECEIVED]: {
    label: {
      en: 'Received',
      ja: '受領済み',
    },
    className: 'text-success',
  },
  Recieved: {
    label: {
      en: 'Received',
      ja: '受領済み',
    },
    className: 'text-success',
  },
  受領済み: {
    label: {
      en: 'Received',
      ja: '受領済み',
    },
    className: 'text-success',
  },
  [STORE_PAYMENT_LOG_TRANSACTION_STATUS.PENDING]: {
    label: {
      en: 'Pending',
      ja: '保留中',
    },
    className: 'text-warning',
  },
  Pending: {
    label: {
      en: 'Pending',
      ja: '保留中',
    },
    className: 'text-warning',
  },
  保留中: {
    label: {
      en: 'Pending',
      ja: '保留中',
    },
    className: 'text-warning',
  },
};

export function getPaymentMethodDisplay(method?: string | null, locale?: string): StatusDisplayConfig {
  if (!method) {
    return { label: '-', className: 'text-foreground' };
  }
  const config = PAYMENT_METHOD_MAP[method];
  if (!config) {
    return { label: method, className: 'text-foreground' };
  }
  const isJp = locale === 'ja' || locale === 'jp' || !locale;
  const label = isJp ? config.label.ja : config.label.en;
  return { label, className: config.className };
}

export function getClubVerificationDisplay(status?: string | null, locale?: string): StatusDisplayConfig {
  if (!status) {
    return { label: '-', className: 'text-foreground' };
  }
  const config = CLUB_VERIFICATION_MAP[status];
  if (!config) {
    return { label: status, className: 'text-foreground' };
  }
  const isJp = locale === 'ja' || locale === 'jp' || !locale;
  const label = isJp ? config.label.ja : config.label.en;
  return { label, className: config.className };
}

export function getTransactionStatusDisplay(status?: string | null, locale?: string): StatusDisplayConfig {
  if (!status) {
    return { label: '-', className: 'text-foreground' };
  }
  const config = TRANSACTION_STATUS_MAP[status];
  if (!config) {
    return { label: status, className: 'text-foreground' };
  }
  const isJp = locale === 'ja' || locale === 'jp' || !locale;
  const label = isJp ? config.label.ja : config.label.en;
  return { label, className: config.className };
}

export const STORE_PAYMENT_LOG_RESERVATION_TYPE = {
  FIRST_BOOKING: 'First booking',
  REGULAR_BOOKING: 'Regular booking',
} as const;

export const RESERVATION_TYPE_MAP: Record<
  string,
  {
    en: string;
    ja: string;
  }
> = {
  'First booking': {
    en: 'First booking',
    ja: '初回予約',
  },
  'first booking': {
    en: 'First booking',
    ja: '初回予約',
  },
  'First Booking': {
    en: 'First booking',
    ja: '初回予約',
  },
  FIRST_BOOKING: {
    en: 'First booking',
    ja: '初回予約',
  },
  first: {
    en: 'First booking',
    ja: '初回予約',
  },
  初回予約: {
    en: 'First booking',
    ja: '初回予約',
  },
  'Regular booking': {
    en: 'Regular booking',
    ja: '通常予約',
  },
  'regular booking': {
    en: 'Regular booking',
    ja: '通常予約',
  },
  'Regular Booking': {
    en: 'Regular booking',
    ja: '通常予約',
  },
  REGULAR_BOOKING: {
    en: 'Regular booking',
    ja: '通常予約',
  },
  regular: {
    en: 'Regular booking',
    ja: '通常予約',
  },
  通常予約: {
    en: 'Regular booking',
    ja: '通常予約',
  },
};

export function getReservationTypeDisplay(type?: string | null, locale?: string): string {
  if (!type) {
    return '-';
  }
  const config = RESERVATION_TYPE_MAP[type];
  if (!config) {
    return type;
  }
  const isJp = locale === 'ja' || locale === 'jp' || !locale;
  return isJp ? config.ja : config.en;
}

export { getPlanTypeLabel } from '@/features/dashboard/reservationLedger/utils/statusLabels';
